export enum RegistrationStatus {
    PENDING,
    SUCCESS,
    FAIL
}

export enum ResponseStatus { // TODO: fix namings (generic status name)
    PENDING,
    SUCCESS,
    FAIL,
    LOGOUT
}

export enum OrderPaymentStatusNames {
    PAID = 'payment_paid',
    UNPAID = 'payment_awaiting',
    WAREHOUSE = 'poland-warehouse'
}
